// ABOUTME: Carries the evaluated readonly state of the node the EditNode form is showing.
// ABOUTME: Defaults to NOT_LOCKED so any component rendered outside the provider stays writable.

import { createContext } from 'react';

import { NodeReadonlyState, NOT_LOCKED } from './types';

export const NodeReadonlyContext = createContext<NodeReadonlyState>(NOT_LOCKED);
